module.exports = __webpack_public_path__ + "static/img/tj2.5e1e617.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tj2.png
// module id = RsZi
// module chunks = 1